import React, { useEffect, useState } from 'react';
import './index.scss';
import { Modal, Button, Form, Input, Radio, SelectOption, Select, StatusTip, notification, ConfigProvider } from 'tea-component';
import { useForm, useField } from 'react-final-form-hooks';
import { useSelector, history } from 'umi';
import { isDataLabAdmin } from '@/pages/datalab/utils/common';
import {checkNullString, getLocalText, translateSpecialWord, useDblIntl} from '@/pages/datalab/utils/utils';
import { useRequest } from 'ahooks';
import { getChartDetail } from '@dbl/services/chart';
import { createChartTag, getChartTagList } from '@dbl/services/chart';
import { getReportList } from '@dbl/services/dashboard';
import Loading from '@/pages/datalab/components/Loading';
import { showErrorMessagetip } from '@/pages/home/components/ErrorMessageTip/ErrorMessageTip';
import { getLastItem } from '@/pages/datalab/pages/WorkBench/CreateReport/utils';
import { getDashboard, updateDashboard } from '@dbl/services/dashboard';
import { layoutItemOption } from '@dbl/core/dashboard';
import {DATALAB_EDITOR} from '@dbl/core/global';
import {CHART_OLD_NAMESPACE} from "@/pages/datalab/models/namespaces";
import { ChartType } from '@dbl/core/chart';
import { useChartSettingsSelector } from '../ChartSettingsV2/context';
import { buildCustomizeSettingForApi } from '../ChartSettingsV2/services/api-upload';
import { ChartCalculateMode } from '@dbl/core/chartEditor';

export function getStatus(meta: any, validating: any): 'validating' | 'error' | 'success' | undefined {
  if (meta.active && validating) {
    return 'validating';
  }
  if (!meta.touched) {
    return undefined;
  }
  return meta.error ? 'error' : 'success';
}


export function SaveModel(props: any) {
  const { dblFormatMessage: multiFormatMessage, commonFormatMessage, isEn } = useDblIntl("multi");
  const { className = '', showSaveModel, setShowSaveModel, namespace, data = {}, title, onSaveSuccess} = props;
  const { taskId: originTaskId } = data;
  const [showReplace, setShowReplace] = useState(true);
  const [duplicateName, setDuplicateName] = useState(false);
  const { 
    dashboardId: urlDashboardId = '', 
    dashboardName: urlDashboardName = '', 
    isTemplateReport = false,
    tab,
    tabId,
  } = history?.location?.query || {};
  const [status, setStatus] = useState<'' | 'loading' | 'empty' | 'error'>('');
  const [reportstatus, setReportstatus] = useState<'' | 'loading' | 'empty' | 'error'>('');
  const [labelOptions, setLabelOptions] = useState<SelectOption[]>([]);
  const [reportOptions, setReportOptions] = useState<SelectOption[]>([]);
  const [showCustomLabelInput, setShowCustomLabelInput] = useState<boolean>(false);
  const [customLabelInputValue, setCustomLabelInputValue] = useState<string>('');
  const chartType = useSelector((state: any) => state[CHART_OLD_NAMESPACE]?.chartType);
  const baseFromContext = useChartSettingsSelector((s) => s.base);
  const { columnDimensions, columnMetrics, mode } = useSelector((state: any) => ({
    columnDimensions: state[CHART_OLD_NAMESPACE]?.columnDimensions ?? [],
    columnMetrics: state[CHART_OLD_NAMESPACE]?.columnMetrics ?? [],
    mode: state[CHART_OLD_NAMESPACE]?.mode ?? ChartCalculateMode.Aggregate,
  }));

  const { gameCode, currentGame, saveColumnInfos, rowLimit, allPrivileges, trendStatus } = useSelector((state: any) => ({
    gameCode: state.datalab.gameCode,
    currentGame: state.datalab.currentGame,
    saveColumnInfos: state?.[namespace]?.save_column_infos ,
    trendStatus: state?.[namespace]?.trendStatus ,
    rowLimit: state?.[namespace]?.rowLimit ,
    allPrivileges: state.privilegesConfig.allPrivileges,
    restState: state?.[namespace]
  }));
  const hasDashboardPrivilege = allPrivileges?.includes(DATALAB_EDITOR.Dashbord);
  
  const { run: runGetReportList } = useRequest(
    () => {
      const params = {
        game_code: gameCode,
      };
      setReportstatus('loading');
      return getReportList(params);
    },
    {
      manual: true,
      onSuccess: (res: any) => {
        const newOptions = [];
        (res?.list || []).forEach((item: any) => {
          
          // 需求要求下拉列表只展示报表列表, 不展示模板报表列表, 所以做了 item.category === 'dashboard' 判断过滤; 数据问题后端说后面优化
          item?.edit && (item?.category === 'dashboard') && newOptions.push({
            value: item?.id,
            text: item?.dashboard_title,
            text_en: item?.dashboard_title,
          });
        });
        setReportOptions(newOptions);
        if (newOptions.length === 0) {
          setReportstatus('empty');
        } else {
          setReportstatus('');
        }
      },
      onError: () => {
        setReportstatus('error');
      },
    },
  );
  
  const { run: runGetChartTagList } = useRequest(
    () => {
      const params = {
        game_code: gameCode,
      };
      setStatus('loading');
      return getChartTagList(params);
    },
    {
      manual: true,
      onSuccess: (res: any) => {
        const newOptions = (res?.labels || []).map((item: string) => ({
          value: item,
          text: item,
          text_en: translateSpecialWord(item, true),
        }));
        setLabelOptions(newOptions);
        if (newOptions.length === 0) {
          setStatus('empty');
        } else {
          setStatus('');
        }
      },
      onError: () => {
        setStatus('error');
      },
    },
  );
  
  const { run: runCreateChartTag, loading: createChartTagLoading } = useRequest(
    (label: string) => {
      const params = {
        game_code: gameCode,
        label,
      };
      return createChartTag(params);
    },
    {
      manual: true,
      onSuccess: (res: any) => {
        const newOptions = (res?.labels || []).map((item: string) => ({
          value: item,
          text: item,
          text_en: translateSpecialWord(item, true),
        }));
        setLabelOptions(newOptions);
        form.change('label', newOptions?.[0]?.value ?? '');
        if (newOptions.length === 0) {
          setStatus('empty');
        } else {
          setStatus('');
        }
        setShowCustomLabelInput(false);
      },
      onError: (res: any) => {
        if (res?.code === 21110) {
          showErrorMessagetip({
            errorCode: 21110,
            content: multiFormatMessage("task_label_same"),
            duration: 3000,
            isClose: true,
            type: 'error',
          });
        }
      },
    },
  );
  
  useEffect(() => {
    runGetChartTagList();
    hasDashboardPrivilege && runGetReportList();
  }, []);
  
  useEffect(() => {
    if (!showCustomLabelInput) {
      setCustomLabelInputValue('');
    }
  }, [showCustomLabelInput]);
  
  useEffect(() => {
    // 关闭弹窗去除重名提示
    if (!showSaveModel) setDuplicateName(false);
  }, [showSaveModel]);
  
  const close = () => {
    setShowSaveModel(false);
  };
  
  const saveToDashboard = () => {
    if (invalid) return;
    onSubmit(true);
  };
  
  const onSubmit = (isSaveToDashboard = false) => {
    const customizeSetting = buildCustomizeSettingForApi({
      chartType,
      base: baseFromContext as Record<string, unknown>,
      draft: {},
      columnDimensions,
      columnMetrics,
      mode,
    });

    const params = {
      taskId: showReplace && data.business_type === Number(businessType.input.value) ? originTaskId : undefined,
      name: name.input.value?.trim(),
      nameCn: nameCn.input.value?.trim(),
      label: label.input.value,
      business_type: Number(businessType.input.value),
      customizeSetting,
      oldId: saveType.input.value === "1" ? originTaskId : undefined,
    };
    if (props?.saveHandle) {
      return props?.saveHandle?.(params, isSaveToDashboard);
    }
    saveHandle(params, isSaveToDashboard);
  };

  // TODO:是否需要保留全部图表taskId?
  const saveHandle = (data: any, isSaveToDashboard = false) => {
    const nameKey=name.input.value?.trim();
    const nameCnKey=nameCn.input.value?.trim();

    props.dispatch({
      type: `${namespace}/saveCondition`,
      payload: {
        game_code: gameCode,
        ...data,
        save_column_infos: {
          ...saveColumnInfos,
          trendStatus: {
            ...(saveColumnInfos?.trendStatus || {}),
            ...(trendStatus || {}),
          },
          saveRowLimits: {
            // ...save_column_infos?.saveRowLimits,
            // 新建的图表是没有id的，是在保存完成才获取到的id，这里给个默认值，就算name相同，下次打开必定有taskId，先读取id，在读取name
            [isSaveToDashboard ? nameKey : originTaskId || nameKey]: rowLimit,
            // [isSaveToDashboard ? nameCnKey : originTaskId || nameCnKey]: rowLimit,
          },
          chartsCfgSave: {
            // 关键：仪表盘加载时从 column_infos.chartsCfgSave[chartType].customizeSetting[storageKey] 读配置
            // 必须将 buildCustomizeSettingForApi 生成的 customizeSetting 注入，否则 DVA 为空时仪表盘读不到配置
            [chartType]: {
              customizeSetting: data.customizeSetting,
            },
          },
        }
      },
      callback: (param: any, resp: any) => {
        if (resp.code === 21101) {
          setDuplicateName(true);
        } else if (resp.code === 0) {
          const id =
            !checkNullString(originTaskId) && !param.task_id
              ? 'save_as_success'
              : 'save_success';
          
          addDashboardChart(resp?.data?.task_id, isSaveToDashboard, () => {
            notification.success({
              description: multiFormatMessage(id, { name: isEn ? param.name : param.name_cn }),
            });
          });
          
          
          if (isSaveToDashboard !== true && (report?.input?.value !== (urlDashboardId || undefined))) {
            if(urlDashboardId) {
              history.push({
                pathname: `/datalab/${gameCode}/WorkBench/MyDashboard/CreateDashboard`,
                query: {
                  dashboardId: urlDashboardId,
                  dashboardName: urlDashboardName,
                  isTemplateReport,
                  tab,
                  tabId,
                }
              });
            } else if (typeof onSaveSuccess === "function") {
              onSaveSuccess({
                from: 'edit',
                taskId: resp?.data?.task_id,
                name: nameKey,
                nameCn: nameCnKey,
                gameCode,
                isEn
              });
              setShowSaveModel(false);
              return;
            } else {
              history.push(`/datalab/${gameCode}/WorkBench/MyAnalysis`);
            }
            
            notification.success({
              description: multiFormatMessage(id, { name: getLocalText(isEn, param.name_cn, param.name) }),
            });
          }
          
        } else { // 错误提示
          notification.error({
            description: multiFormatMessage('save_error', {code: resp.code ?? -1})
          });
        }
      },
    });
  };
  
  // 图表添加至报表
  const addDashboardChart = (chartId: number, isSaveToDashboard: boolean, callback: () => void) => {
    const dashboardId = report?.input?.value ||'';
    // 没选择添加至报表不执行
    if (!dashboardId) return;
    const params = {
      game_code: gameCode,
      id: dashboardId,
    };
    // 第一步：请求报表详情
    getDashboard(params).then((dashboard: any) => {
      const { id, dashboard_title, template_title, category, show_contact } = dashboard || {};
      // 第二步：请求图表详情
      const taskDetailParams = {
        game_code: gameCode,
        task_id: chartId || originTaskId,
      };
      getChartDetail(taskDetailParams).then((chart: any) => {
        // 第三步：计算更新视图
        const { chart_type: chartType, task_id } = chart || {};
        const isExist = dashboard?.tabs?.some(tab => tab?.layouts?.some((v: any) => v?.task_id === task_id));

        if (!dashboard?.tabs?.[0]) {
          dashboard?.tabs?.push({layouts: [], filters: [], tabId: '-1', tabName: ''});
        }
        // 使用路由传递的tab参数，将新建图表加入指定tab
        const tabLayout = dashboard?.tabs?.find((item: { tabId: string; tabName: string; }) => item?.tabId === tabId || item?.tabId === tab || item?.tabName === tab) || dashboard?.tabs?.[0];
        const { layouts=[] } = tabLayout || { layouts: [] };

        if (!isExist) { // 保存的图表 不存在报表中时向第一个页签添加图表
          const lastFilter = getLastItem(layouts || []);
          const { x: lx, y: ly, w: lw, h: lh } = lastFilter || {};
          const option = layoutItemOption?.[chartType] || layoutItemOption.default;
          const { w, } = option;
          let x;
          let y;
          if (lx + lw + w <= 6) {
            x = lx + lw;
            y = ly;
          } else {
            x = 0;
            y = ly + lh;
          }
          const addItem = {
            i: `${chartType}-${Math.random()}`,
            chartType,
            ...option,
            x,
            y,
            isDraggable: true,
            moved: false,
            static: false,
            isBounded: undefined,
            isResizable: undefined,
            maxH: undefined,
            maxW: undefined,
            ...chart,
          };
          layouts?.push(addItem);
        }
        const json_metadata = JSON.stringify({ tabs: dashboard?.tabs });
        const ids = layouts?.filter((v: any) => v?.chart_type)?.map((w: any) => w?.task_id)?.join(',') ?? task_id;
        const isDashboard = category === "dashboard";
        const updateParams: any = {
          id,
          game_code: gameCode,
          dashboard_title,
          description: '',
          json_metadata,
          chart_ids: ids,
          template_title: isDashboard ? undefined : template_title,
          set_as_template: !isDashboard,
          show_contact,
        };
        // 第四步：更新报表
        updateDashboard(updateParams).then(() => {
          if (isSaveToDashboard === true || (urlDashboardId && dashboardId === urlDashboardId)) {
            // 跳转至报表编辑页
            history.push({
              pathname: `/datalab/${gameCode}/WorkBench/MyDashboard/CreateDashboard`,
              query: {
                dashboardId,
                dashboardName: isDashboard ? dashboard_title : template_title,
                isTemplateReport,
                tab,
                tabId
              }
            });
            callback();
            return;
          }
        }).catch((err) => {
          console.log(err);
        });
      });
    }).catch((err) => {
      console.log(err);
    });
  };
  
  
  const { form, handleSubmit, invalid, validating, submitting } = useForm({
    onSubmit,
    initialValuesEqual: () => true,
    validate: ({ name, nameCn, label }: { name: string; nameCn: string; label: string; }) => {
      
      function getValidateNameText(name: string, langKey: string) {
        if (!name?.replaceAll(' ', '')) return multiFormatMessage(langKey);
        if (name?.length > 50) return commonFormatMessage("valid_name_length", {count: '50'});
        return;
      }
      
      return {
        name: getValidateNameText(name, "task_name_validate"),
        nameCn: (nameCn?.length > 50) ? commonFormatMessage("valid_name_length", {count: '50'}) : undefined,
        label: !label ? multiFormatMessage("task_label_validate") : undefined,
        businessType: !businessType ? multiFormatMessage("task_permission_validate") : undefined,
      };
    },
  });
  
  const name = useField('name', form);
  const nameCn = useField('nameCn', form);
  const label = useField('label', form);
  const businessType = useField('businessType', form);
  const saveType = useField('saveType', form);
  const report = useField('report', form);

  useEffect(() => {
    setShowReplace(saveType.input.value === '0');
    let newName = name.input.value;
    let newNameCn = nameCn.input.value;
    const originName = name.input.value.slice(0, Math.min(name.input.value.length, data.name ? data.name.length : 0));
    const originNameCn = nameCn.input.value.slice(0, Math.min(nameCn.input.value.length, data.nameCn ? data.nameCn.length : 0));
    if (data.name === originName && !checkNullString(data.name)) {
      newName = saveType.input.value === '0' ? originName : `${originName}${multiFormatMessage("copy")}`;
    }
    if (data.nameCn === originNameCn && !checkNullString(data.nameCn)) {
      newNameCn = saveType.input.value === '0' ? originNameCn : `${originNameCn}${multiFormatMessage("copy")}`;
    }
    // form.initialize({
    //   ...data,
    //   name: newName,
    //   label: label.input.value,
    //   businessType: businessType.input.value,
    //   saveType: saveType.input.value,
    // });
    form.change('name', newName);
    form.change('nameCn', newNameCn);
  }, [JSON.stringify(saveType.input.value), isEn]);
  
  useEffect(() => {
    form.initialize({
      ...data,
      name: originTaskId ? data.name : '',
      nameCn: originTaskId ? data.nameCn : '',
      // eslint-disable-next-line no-nested-ternary
      businessType: isDataLabAdmin(currentGame) ? (data.business_type ? String(data.business_type) : '0') : '0',
      report: urlDashboardId || undefined,
      saveType: '0',
    });
    // 如果后端返回的数据没有包含 图表的标签label数据, 前端要自己补充
    const label = data?.label;
    if (label) {
      const isHave = labelOptions.some(({value}) => value === label);
      !isHave && setLabelOptions((labelOptions) => [{value: label, text: label, text_en: label}, ...labelOptions]);
    }
    
  }, [JSON.stringify(data)]);
  
  return (
    <Modal className={`dbl-analysis-save-model ${className}`} visible={showSaveModel} caption={title} onClose={close}>
      <Loading loading={createChartTagLoading}>
        <ConfigProvider locale={isEn ? 'en' : 'zh'}>
          <form onSubmit={handleSubmit} onKeyDown={(e) => {
          // 【Datalab】【交互优化】图表保存弹窗，敲击键盘Enter键时，无需触发保存功能
            if (e.key === 'Enter') {
              e.preventDefault();
            }
          }}>
            <Modal.Body className={"dbl-confirm-model dbl-analysize-confirm-model-box"}>
              <Form>
                {originTaskId && data.business_type === Number(businessType.input.value) ? ( // 若任务id存在并且选择的来源和所选的来源相同，才出现
                  <Form.Item
                    className={'dbl-analysize-save-keep-type'}
                    label={multiFormatMessage("keep_type")}
                    showStatusIcon={false}
                    required
                    status={showReplace ? 'error' : getStatus(saveType.meta, validating)}
                    message={
                      showReplace
                        ? multiFormatMessage("replace_info")
                        : getStatus(saveType.meta, validating) === 'error' && saveType.meta.error
                    }
                  >
                    <div>
                      <Radio.Group {...saveType.input}>
                        <Radio name="0">{multiFormatMessage("keep_type_replace")}</Radio>
                        <Radio name="1">{multiFormatMessage("keep_type_save_as")}</Radio>
                      </Radio.Group>
                    </div>
                  </Form.Item>
                ) : (
                  ''
                )}
                <Form.Item
                  label={multiFormatMessage("task_name")}
                  status={duplicateName ? 'error' : getStatus(name.meta, validating)}
                  showStatusIcon={false}
                  required
                  message={
                    duplicateName
                      ? multiFormatMessage("task_name_same")
                      : getStatus(name.meta, validating) === 'error' && name.meta.error
                  }
                >
                  <Input placeholder={multiFormatMessage("task_name_placeholder")} size="full" autoComplete="off" {...name.input} />
                </Form.Item>
                <Form.Item
                  label={multiFormatMessage("task_name_cn")}
                  // status={getStatus(nameCn.meta, validating)}
                  showStatusIcon={false}
                  // required
                  // message={getStatus(nameCn.meta, validating) === 'error' && nameCn.meta.error}
                >
                  <Input placeholder={multiFormatMessage("task_name_cn_placeholder")} size="full" autoComplete="off" {...nameCn.input} />
                </Form.Item>
                {/* <Form.Item
                label={multiFormatMessage("task_permission")}
                showStatusIcon={false}
                status={getStatus(businessType.meta, validating)}
                message={getStatus(businessType.meta, validating) === 'error' && businessType.meta.error}
              >
                <Radio.Group {...businessType.input}>
                  <Radio name="0">{multiFormatMessage("visible_to_me_only")}</Radio>
                  <Bubble
                    content={<span>{multiFormatMessage("permission_info")}</span>}
                    style={{ display: !isDataLabAdmin(currentGame) || data.type === 1 ? 'block' : 'none' }}
                  >
                    <Radio name="1" disabled={!isDataLabAdmin(currentGame) || data.type === 1}>
                      {multiFormatMessage("visible_to_business")}
                    </Radio>
                  </Bubble>
                </Radio.Group>
              </Form.Item> */}
                <Form.Item
                  label={multiFormatMessage("task_label")}
                  showStatusIcon={false}
                  required
                  status={getStatus(label.meta, validating)}
                  message={getStatus(label.meta, validating) === 'error' && label.meta.error}
                >
                  <Select
                    placeholder={multiFormatMessage("task_label_placeholder")}
                    size="full"
                    appearance="button"
                    searchable={!showCustomLabelInput}
                    matchButtonWidth
                    value={(label.input.value && originTaskId) ? label.input.value : undefined}
                    onChange={(value) => {
                      form.change('label', value);
                    }}
                    options={!showCustomLabelInput ? labelOptions.map(opt => ({ value: opt.value, text: isEn ? opt.text_en : opt.text })) : []}
                    boxClassName={showCustomLabelInput ? 'confirm-model-customize' : ''}
                    tips={
                      // eslint-disable-next-line no-nested-ternary
                      showCustomLabelInput ? (false) : status && labelOptions.length === 0 ? (
                        <StatusTip
                          status={status}
                          emptyText={commonFormatMessage("no_data")}
                          onRetry={() => {
                            runGetChartTagList();
                          }}
                        />
                      ) : undefined
                    }
                    onOpen={() => {
                      setShowCustomLabelInput(false);
                    }}
                    footer={
                      !showCustomLabelInput ? (
                        <div
                          style={{ color: '#0076ff', textAlign: 'left', cursor: 'pointer' }}
                          onClick={() => {
                            setShowCustomLabelInput(true);
                          }}
                        >
                          {multiFormatMessage("task_custom")}
                        </div>
                      ) : (
                        <>
                          <Input
                            size="full"
                            placeholder={multiFormatMessage("task_custom_placeholder")}
                            value={customLabelInputValue}
                            onChange={(value) => {
                              setCustomLabelInputValue(value);
                            }}
                          />
                          <div className="confirm-flex-end" style={{ marginTop: '10px' }}>
                            <Button
                              style={{ minWidth: 50, padding: '0px 15px' }}
                              type="primary"
                              disabled={!customLabelInputValue}
                              onClick={() => {
                                runCreateChartTag(customLabelInputValue);
                              }}
                            >
                              {commonFormatMessage("confirm")}
                            </Button>
                            <Button
                              style={{ minWidth: 50, padding: '0px 15px' }}
                              type="weak"
                              onClick={() => {
                                setShowCustomLabelInput(false);
                              }}
                            >
                              {commonFormatMessage("return")}
                            </Button>
                          </div>
                        </>
                      )}
                  />
                </Form.Item>
                {
                  hasDashboardPrivilege ? (<Form.Item
                    className="dbl-analysis-save-model-report-label"
                    label={multiFormatMessage("report_label")}
                    showStatusIcon={false}
                  >
                    <Select
                      clearable
                      placeholder={multiFormatMessage("report_label_placeholder")}
                      size="full"
                      appearance="button"
                      searchable={true}
                      matchButtonWidth
                      value={(report.input.value) ? report.input.value : undefined}
                      onChange={(value) => {
                        form.change('report', value);
                      }}
                      options={reportOptions}
                      tips={
                        reportstatus && reportOptions.length === 0 ? (
                          <StatusTip
                            status={reportstatus}
                            emptyText={commonFormatMessage("no_data")}
                            onRetry={() => {
                              runGetReportList();
                            }}
                          />
                        ) : undefined
                      }
                    />
                  </Form.Item>) : ''
                }
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button type="primary" htmlType="submit" loading={submitting} disabled={submitting || invalid}>
                {commonFormatMessage("save")}
              </Button>
              {
                hasDashboardPrivilege ? (<Button className="dbl-analysis-save-to-dashboard-btn" type="weak" htmlType="button" disabled={submitting || invalid || !report?.input?.value} onClick={saveToDashboard}>
                  {commonFormatMessage("save_to")}
                </Button>) : ''
              }
              <Button type="weak" htmlType="button" onClick={close}>
                {commonFormatMessage("cancel")}
              </Button>
            </Modal.Footer>
          </form>
        </ConfigProvider>
      </Loading>
    </Modal>
  );
}
